import { createRestConnectionForm } from "./rest-connection-form";
import { SWAGGER_SPEC } from "./rest-connection-specs";

/** Swagger API. Everything but the spec lives in `rest-connection-form.tsx`. */
const createConnectionRestapi = createRestConnectionForm(SWAGGER_SPEC);
export { createConnectionRestapi as CreateConnectionRestapi };
